import React from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";

const AddVehicleModal = ({ show, onHide, onSubmit }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());

    // Convert numeric fields
    data.year = parseInt(data.year) || 0;
    data.hoursUsed = parseInt(data.hoursUsed) || 0;
    data.atvValidityYears = parseInt(data.atvValidityYears) || 4;

    onSubmit(data);
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" className="workshop-modal-scope">
      <Modal.Header closeButton>
        <Modal.Title>Tambah Kendaraan Baru</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={6}>
              <Form.Group style={{ marginBottom: "16px" }}>
                <Form.Label>Nama Kendaraan</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  placeholder="Masukkan nama kendaraan"
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group style={{ marginBottom: "16px" }}>
                <Form.Label>Nomor Plat</Form.Label>
                <Form.Control
                  type="text"
                  name="plateNumber"
                  placeholder="Masukkan nomor plat"
                  required
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group style={{ marginBottom: "16px" }}>
                <Form.Label>Model</Form.Label>
                <Form.Control
                  type="text"
                  name="model"
                  placeholder="Masukkan model kendaraan"
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group style={{ marginBottom: "16px" }}>
                <Form.Label>Tahun</Form.Label>
                <Form.Control
                  type="number"
                  name="year"
                  placeholder="Masukkan tahun kendaraan"
                  required
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group style={{ marginBottom: "16px" }}>
                <Form.Label>Nomor Rangka</Form.Label>
                <Form.Control
                  type="text"
                  name="chassisNumber"
                  placeholder="Masukkan nomor rangka"
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group style={{ marginBottom: "16px" }}>
                <Form.Label>Nomor Mesin</Form.Label>
                <Form.Control
                  type="text"
                  name="engineNumber"
                  placeholder="Masukkan nomor mesin"
                  required
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group style={{ marginBottom: "16px" }}>
                <Form.Label>Masa Berlaku ATV (tahun)</Form.Label>
                <Form.Control
                  type="number"
                  name="atvValidityYears"
                  placeholder="Masukkan masa berlaku ATV"
                  min="1"
                  max="10"
                  defaultValue="4"
                />
              </Form.Group>
            </Col>
          </Row>
          <Form.Group style={{ marginBottom: "16px" }}>
            <Form.Label>Status</Form.Label>
            <Form.Select name="status" defaultValue="ready">
              <option value="ready">Siap Pakai</option>
              <option value="maintenance">Perlu Pengecekan</option>
              <option value="service">Butuh Perbaikan</option>
            </Form.Select>
          </Form.Group>
          <Modal.Footer>
            <Button variant="secondary" onClick={onHide}>
              Batal
            </Button>
            <Button variant="primary" type="submit">
              Simpan
            </Button>
          </Modal.Footer>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default AddVehicleModal;
